(() => {
  const toast = document.getElementById('ck-cart-feedback');
  if (!toast) return;
  let timer;
  let revision = 0;

  function startTimer() {
    clearTimeout(timer);
    timer = setTimeout(() => {
      if (toast.matches(':hover') || toast.contains(document.activeElement)) {
        startTimer();
        return;
      }
      toast.classList.remove('is-visible');
    }, 6000);
  }

  toast.addEventListener('pointerenter', () => clearTimeout(timer));
  toast.addEventListener('focusin', () => clearTimeout(timer));
  toast.addEventListener('pointerleave', startTimer);
  toast.addEventListener('focusout', startTimer);

  window.CKCartFeedback = {
    show(response, quantity = 1) {
      const items = response.items || [response];
      const products = items.map((item) => {
        const title = item.product_title || item.title || '';
        let name = title;
        if (['8041131999322', '8041132195930', '8041132327002'].includes(String(item.product_id))) {
          name = title.split('|')[0].split('·').pop().trim();
        }
        const variant = item.variant_title;
        if (variant && variant !== 'Default Title') {
          name += ' · ' + variant.replace(/\s*L\b/g, ' L').trim();
        }
        return (quantity > 1 ? quantity + ' × ' : '') + name;
      }).join(', ');

      clearTimeout(timer);
      const currentRevision = ++revision;
      toast.replaceChildren();
      requestAnimationFrame(() => {
        if (currentRevision !== revision) return;
        const check = document.createElement('span');
        check.className = 'ck-cart-feedback__check';
        check.setAttribute('aria-hidden', 'true');
        check.textContent = '✓';
        const text = document.createElement('span');
        text.className = 'ck-cart-feedback__text';
        const title = document.createElement('span');
        title.className = 'ck-cart-feedback__title';
        title.textContent = toast.dataset.success;
        const product = document.createElement('span');
        product.className = 'ck-cart-feedback__product';
        product.textContent = products;
        text.append(title, product);
        const action = document.createElement('a');
        action.className = 'ck-cart-feedback__action';
        action.href = toast.dataset.cartUrl;
        action.textContent = toast.dataset.cartLabel;
        action.addEventListener('click', (event) => {
          const drawer = document.querySelector('cart-drawer');
          if (!drawer || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          clearTimeout(timer);
          toast.classList.remove('is-visible');
          drawer.open(document.getElementById('cart-icon-bubble') || action);
        });
        text.append(action);
        toast.append(check, text);
        toast.classList.add('is-visible');
        startTimer();
      });
    }
  };
})();

